const inviteClientUserValidation = {
  firstName: {
    type: 'string',
    required: true,
  },
  lastName: {
    type: 'string',
    required: true,
  },
  email: {
    type: 'string',
    required: true,
    email: true,
  },
  accessUntil: {
    type: 'string',
    required: true,
  },
};

export const inviteClientUsersValidation = {
  clients: {
    type: 'array',
    required: true,
    minSize: 1,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: inviteClientUserValidation,
    },
  },
};

export const rejectClientUsersValidation = {
  decisionNote: {
    type: 'string',
    required: true,
  },
};
